// import { Route, Routes, useLocation } from 'react-router'

import { Route, Routes, useLocation } from 'react-router'

import BookDemo from './pages/BookDemo'
import Features from './pages/Features'
import Footer from './components/site/Footer'
import Home from './pages/Home'
import Integrations from './pages/Integrations'
import Login from './pages/Login'
import Nav from './components/site/Nav'
import Pricing from './pages/Pricing'
import ProPartners from './pages/ProPartners'
import ToolPage from './pages/ToolPage'
import Tools from './pages/Tools'
import { useEffect } from 'react'

// import DashboardMock from './pages/mockups/Dashboard'
// import ProviderDashboardMock from './pages/mockups/ProviderDashboard'
// import AdminDashboardMock from './pages/mockups/AdminDashboard'
// import SupportDashboardMock from './pages/mockups/SupportDashboard'
// import AddEmployeeMock from './pages/mockups/AddEmployee'
// import AllEmployeesMock from './pages/mockups/AllEmployees'
// import PayrollRegisterMock from './pages/mockups/PayrollRegister'
// import PayrollRunMock from './pages/mockups/PayrollRun'
// import RoePanelMock from './pages/mockups/RoePanel'
// import PayrollCustomMock from './pages/mockups/PayrollCustom'
// import StatHolidayMock from './pages/mockups/StatHoliday'
// import ComplianceMock from './pages/mockups/Compliance'
// import RemittancesMock from './pages/mockups/Remittances'
// import StructureMock from './pages/mockups/Structure'
// import JobCostingMock from './pages/mockups/JobCosting'
// import CraRemittanceMock from './pages/mockups/CraRemittance'
// import EmployeeListMock from './pages/mockups/EmployeeList'
// import EmployeeSetupMock from './pages/mockups/EmployeeSetup'
// import RqRemittanceMock from './pages/mockups/RqRemittance'
// import T4SetupMock from './pages/mockups/T4Setup'
// import T4SummaryMock from './pages/mockups/T4Summary'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

export default function App() {
  // const { pathname } = useLocation()
  // const bare = pathname.startsWith('/mockups')

  // if (bare) {
  //   return (
  //     <Routes>
  //       <Route path="/mockups/dashboard" element={<DashboardMock />} />
  //       <Route path="/mockups/provider" element={<ProviderDashboardMock />} />
  //       <Route path="/mockups/admin" element={<AdminDashboardMock />} />
  //       <Route path="/mockups/support" element={<SupportDashboardMock />} />
  //       <Route path="/mockups/add-employee" element={<AddEmployeeMock />} />
  //       <Route path="/mockups/employees" element={<AllEmployeesMock />} />
  //       <Route path="/mockups/payroll-register" element={<PayrollRegisterMock />} />
  //       <Route path="/mockups/payroll-run" element={<PayrollRunMock />} />
  //       <Route path="/mockups/roe-panel" element={<RoePanelMock />} />
  //       <Route path="/mockups/payroll-custom" element={<PayrollCustomMock />} />
  //       <Route path="/mockups/stat-holiday" element={<StatHolidayMock />} />
  //       <Route path="/mockups/compliance" element={<ComplianceMock />} />
  //       <Route path="/mockups/remittances" element={<RemittancesMock />} />
  //       <Route path="/mockups/structure" element={<StructureMock />} />
  //       <Route path="/mockups/job-costing" element={<JobCostingMock />} />
  //       <Route path="/mockups/cra-remittance" element={<CraRemittanceMock />} />
  //       <Route path="/mockups/employee-list" element={<EmployeeListMock />} />
  //       <Route path="/mockups/employee-setup" element={<EmployeeSetupMock />} />
  //       <Route path="/mockups/rq-remittance" element={<RqRemittanceMock />} />
  //       <Route path="/mockups/t4-setup" element={<T4SetupMock />} />
  //       <Route path="/mockups/t4-summary" element={<T4SummaryMock />} />
  //     </Routes>
  //   )
  // }

  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Nav />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/tools/:slug" element={<ToolPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/book-a-demo" element={<BookDemo />} />
          <Route path="/pro-partners" element={<ProPartners />} />
          <Route path="*" element={`<NoFoundPage />`} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}
